import { loadDirFromApi } from "../../utils/markdownUtil";

const blogApi = "https://api.github.com/repos/yungkei/blogs/contents";

export default async function getData() {
    const loadData = new Promise((resolve) => {
        loadDirFromApi(blogApi).then(data => {
            resolve(data);
        });
    });
    return loadData;
}